export const getSearchSuggestions = (
  searchQuery: string,
  successCallback: (data: any) => void,
  errorCallback: () => void,
): void => {
  const url = `/apis/search/suggest?s=${encodeURI(searchQuery)}`;

  fetch(url)
    .then((resp: Response) => resp.json())
    .then((data): void => {
      successCallback(data);
    })
    .catch((): void => {
      errorCallback();
    });
};

export const getSearchPlace = (
  placeId: string,
  successCallback: (data: any) => void,
  errorCallback: () => void,
): void => {
  const url = `/apis/search/GetPlaceDetails?plid=${placeId}`;

  fetch(url)
    .then((resp: Response) => resp.json())
    .then((data): void => {
      successCallback(data);
    })
    .catch((): void => {
      errorCallback();
    });
};
